import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=74e6bf2c"
import script from "./logout.vue?vue&type=script&lang=ts"
export * from "./logout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports